/* tslint:disable:max-line-length */
import * as React from 'react';
import pure from 'recompose/pure';

class DocumentListIcon extends React.Component<{ style: any }> {
  render() {
    return <svg
      viewBox="0 0 70 56"
      width="70px"
      height="56px"
      fill="currentcolor" {...this.props}>
      <g
        id="Artboard"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M4,12 L66,12 C67.1045695,12 68,12.8954305 68,14 L68,42 C68,43.1045695 67.1045695,44 66,44 L4,44 C2.8954305,44 2,43.1045695 2,42 L2,14 C2,12.8954305 2.8954305,12 4,12 Z M8.5,19 C7.67157288,19 7,19.6715729 7,20.5 C7,21.3284271 7.67157288,22 8.5,22 L61.5,22 C62.3284271,22 63,21.3284271 63,20.5 C63,19.6715729 62.3284271,19 61.5,19 L8.5,19 Z M8.5,24 C7.67157288,24 7,24.6715729 7,25.5 C7,26.3284271 7.67157288,27 8.5,27 L61.5,27 C62.3284271,27 63,26.3284271 63,25.5 C63,24.6715729 62.3284271,24 61.5,24 L8.5,24 Z M8.5,29 C7.67157288,29 7,29.6715729 7,30.5 C7,31.3284271 7.67157288,32 8.5,32 L61.5,32 C62.3284271,32 63,31.3284271 63,30.5 C63,29.6715729 62.3284271,29 61.5,29 L8.5,29 Z M8.5,34 C7.67157288,34 7,34.6715729 7,35.5 C7,36.3284271 7.67157288,37 8.5,37 L61.5,37 C62.3284271,37 63,36.3284271 63,35.5 C63,34.6715729 62.3284271,34 61.5,34 L8.5,34 Z"
          id="Rectangle-38"
          fill="#D8D8D8"
        />
      </g>
    </svg>;
  }
}

const Icon = pure(DocumentListIcon);
Icon.displayName = 'DocumentListIcon';
export { Icon as DocumentListIcon };
